import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/admin/Dashboard';
import AppNotFound from '@/common/layout/pages/AppNotFound';
import AppForbidden from '@/common/layout/pages/AppForbidden';
import AppError from '@/common/layout/pages/AppError';

// System
import Login from '@/components/admin/auth/Login';
import LoginCiudadania from '@/components/admin/auth/LoginCiudadania';
import LoginNit from '@/components/admin/auth/LoginNit';
import Account from '@/components/admin/account/Account';
import Entidad from '@/components/admin/entidad/Entidad';
import Usuario from '@/components/admin/usuario/Usuario';
import Modulo from '@/components/admin/modulo/Modulo';
import Preferencias from '@/components/admin/preferencias/Preferencias';
import Log from '@/components/admin/Log';

// Administrador
import AdministradorCaso from '@/components/admin/administrador_casos/AdministradorCaso';
import Canales from '@/components/admin/canales/Canales';
import PuntoAtencion from '@/components/admin/puntos_atencion/PuntoAtencion';
import Tramite from '@/components/admin/tramites/Tramite';

// Operadores
import OperadoresPuntoAtencion from '@/components/admin/operadores/PuntoAtencion';
import OperadoresPendientes from '@/components/admin/operadores/Pendientes';
import OperadoresHistorial from '@/components/admin/operadores/Historial';
import OperadoresChat from '@/components/admin/operadores/ChatOperador';
import OperadoresConvesacion from '@/components/admin/operadores/Conversacion';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login-ciudadania',
      name: 'LoginCiudadania',
      component: LoginCiudadania
    },
    {
      path: '/login-nit',
      name: 'LoginNit',
      component: LoginNit
    },
    {
      path: '/usuarios',
      name: 'Usuario',
      component: Usuario
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/entidades',
      name: 'Entidad',
      component: Entidad
    },
    {
      path: '/parametros',
      name: 'Preferencias',
      component: Preferencias
    },
    {
      path: '/modulos',
      name: 'Módulo',
      component: Modulo
    },
    {
      path: '/admin-casos',
      name: 'Administrador de casos',
      component: AdministradorCaso
    },
    {
      path: '/puntos',
      name: 'Puntos de atención',
      component: PuntoAtencion
    },
    {
      path: '/logs',
      name: 'Logs',
      component: Log
    },
    {
      path: '/canales',
      name: 'Canales',
      component: Canales
    },
    {
      path: '/operadores',
      name: 'Puntos de atención disponibles',
      component: OperadoresPuntoAtencion
    },
    {
      path: '/puntos-atencion',
      name: 'Lista de puntos de atención',
      component: OperadoresPuntoAtencion
    },
    {
      path: '/chat/:id',
      name: 'ChatOperador',
      component: OperadoresChat
    },
    {
      path: '/pendientes',
      name: 'Pendientes',
      component: OperadoresPendientes
    },
    {
      path: '/conversacion/:cubiculo/:id',
      name: 'ChatConversacion',
      component: OperadoresConvesacion
    },
    {
      path: '/historial',
      name: 'Historial',
      component: OperadoresHistorial
    },
    {
      path: '/tramites',
      name: 'Tramites',
      component: Tramite
    },
    {
      path: '/404',
      component: AppNotFound
    },
    {
      path: '/403',
      component: AppForbidden
    },
    {
      path: '/500',
      component: AppError
    },
    {
      path: '*',
      component: AppNotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js